
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1 class="mb-0">{{personnage.nom}}</h1>
      {{joueur.nomComplet}}
    </div>
    <div class="pb-2 mb-3 border-bottom" *ngIf="joueur.contactUrgence">
      <h2 class="mb-0">Contact d'urgence</h2>
      <span>{{joueur.contactUrgence.nomComplet}}, {{joueur.contactUrgence.relation}} - {{joueur.contactUrgence.numero}}</span>
    </div>
    <div class="row">
      PT: {{this.legions.pointTolerance.get(personnage.legion)}}
    </div>
    <div class="row">
      <div class="col-1">
        {{this.legions.values.get(personnage.legion)}}
      </div>
      <div class="col-1">
        {{this.astres.values.get(personnage.astre1)}}
      </div>
      <div class="col-1" *ngIf="personnage.astre2">
        {{this.astres.values.get(personnage.astre2)}}
      </div>
    </div>
    <h2>Compétence</h2>
    <div class="row">
      <ul class="list-group" *ngFor="let competencePersonnage of getCompetencesPersonnage()">
        <span>
          {{competencePersonnage.description?.nom}}
          <i class="list-group-item" *ngFor="let item of [].constructor(competencePersonnage.competence.niveau)" class="fas fa-solid fa-star">★</i>
        </span>
      </ul>
    </div>
    <div *ngFor="let sortPersonnages of getSortsPersonnage()">
      <h2>{{sortPersonnages.name}}</h2>
      <div class="row">
        <ul class="list-group" *ngFor="let sort of sortPersonnages.sorts">
            {{sort.description?.nom}}
        </ul>
      </div>
    </div>
  </div>